import React from 'react';
import { InboxIcon } from 'lucide-react';
import type { PtoRequest } from '../../types/hr';
import { formatDate, formatDays, formatRange } from '../../utils/format';
import { cancelMyRequest } from '../../utils/selfService';
import { policyName } from '../../utils/timeOff';
import { Button } from '../ui/Button';
import { EmptyState } from '../ui/EmptyState';
import { RequestStatusBadge } from './RequestStatusBadge';
interface MyRequestsTableProps {
  requests: PtoRequest[];
  managerName: string;
}
export function MyRequestsTable({
  requests,
  managerName
}: MyRequestsTableProps) {
  if (requests.length === 0) {
    return <div className="px-6 pb-6" data-id="element-746" data-mp="22hj7mjswowha">
        <EmptyState icon={InboxIcon} title="No requests here" description="Requests you submit will show up with their status and approver." data-id="element-747" data-mp="27g490mjw9m7b" />
      </div>;
  }
  return <div className="overflow-x-auto" data-id="element-748" data-mp="2bjinh8s6puin">
      <table className="w-full min-w-[820px] text-left text-sm" data-id="element-749" data-mp="2ggitxksy4zaa">
        <thead data-id="element-750" data-mp="2geppmc5t2r5g">
          <tr className="border-y border-slate-100 bg-canvas/70 text-[11px] font-semibold uppercase tracking-wider text-muted" data-id="element-751" data-mp="1v63rokbl25pk">
            <th scope="col" className="px-6 py-2.5" data-id="element-752" data-mp="1r48rxk9aw0dw">Dates</th>
            <th scope="col" className="px-6 py-2.5" data-id="element-753" data-mp="1r6uz3isa4dvl">Policy</th>
            <th scope="col" className="px-6 py-2.5" data-id="element-754" data-mp="1m5xj9cuqrvx9">Note</th>
            <th scope="col" className="px-6 py-2.5" data-id="element-755" data-mp="1h6ubvlrahdm4">Submitted</th>
            <th scope="col" className="px-6 py-2.5" data-id="element-756" data-mp="1h8f4v6xygohv">Status</th>
            <th scope="col" className="px-6 py-2.5" data-id="element-757" data-mp="2esrq36ymyws9">Approver</th>
            <th scope="col" className="px-6 py-2.5 text-right" data-id="element-758" data-mp="29v88bx2qc1vk">
              <span className="sr-only" data-id="element-759" data-mp="29x2x5mh4ge4x">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100" data-id="element-760" data-mp="2526rhjiyps9c">
          {requests.map(r => <tr key={r.id} className="transition-colors hover:bg-azure/[0.03]" data-id="element-761" data-mp="204wxrrojiufp">
              <td className="whitespace-nowrap px-6 py-3.5" data-id="element-762" data-mp="2xlcby4fx41mk">
                <span className="block font-medium text-navy" data-id="element-763" data-mp="2stc8w34jwslr">
                  {formatRange(r.start, r.end)}, {r.start.slice(0, 4)}
                </span>
                <span className="block text-xs text-muted" data-id="element-764" data-mp="qx3lumb869s2">{formatDays(r.days)}</span>
              </td>
              <td className="px-6 py-3.5 text-slate-600" data-id="element-765" data-mp="uzzzdylwrfp5">{policyName(r.policyId)}</td>
              <td className="max-w-[220px] truncate px-6 py-3.5 text-xs italic text-slate-500" data-id="element-766" data-mp="h68pgp49ltsw">“{r.note}”</td>
              <td className="whitespace-nowrap px-6 py-3.5 text-slate-600" data-id="element-767" data-mp="m3haqykpmdyd">{formatDate(r.submitted, 'MMM d')}</td>
              <td className="px-6 py-3.5" data-id="element-768" data-mp="7antb7lvnnr2">
                <RequestStatusBadge status={r.status} data-id="element-769" data-mp="c8gybxbg2bpr" />
              </td>
              <td className="whitespace-nowrap px-6 py-3.5 text-slate-600" data-id="element-770" data-mp="3udagy4fkqyp8">
                {r.status === 'pending' ? <span className="text-muted" data-id="element-771" data-mp="37r613le73gs">Awaiting {managerName}</span> : r.status === 'cancelled' ? <span className="text-muted" data-id="element-772" data-mp="1sm74d9m4ja21">Cancelled by you{r.decidedOn ? ` · ${formatDate(r.decidedOn, 'MMM d')}` : ''}</span> : <>
                    {r.approver ?? '—'}
                    {r.decidedOn && <span className="block text-[11px] text-muted" data-id="element-773" data-mp="22pktpw670qqg">{formatDate(r.decidedOn, 'MMM d')}</span>}
                  </>}
              </td>
              <td className="px-6 py-3.5 text-right" data-id="element-774" data-mp="2gik63paoi4ts">
                {r.status === 'pending' && <Button size="sm" variant="danger" onClick={() => cancelMyRequest(r)} data-id="element-775" data-mp="2bopocremvzxc">
                    Cancel
                  </Button>}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}